export default (theme) => ({
    root: {
        display: 'flex',
        paddingTop: 15,
        boxSizing: 'border-box',
    },
    icons: {
        width: 60,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    formIcon: {
        width: 25,
    },
    lockIcon: {},
    lineBlock: {
        display: 'flex',
        width: 'calc(100% - 60px)',
        borderBottom: `1px solid ${theme.colors.grey[100]}`,
        marginRight: 15,
        paddingBottom: 12,
    },
    positions: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        '& > div': {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            alignItems: 'flex-start',
        },
    },
    position: {
        marginBottom: 3,
    },
    menu: {
        zIndex: 1000,
    },
    subMenu: {
        zIndex: 1000,
    },
});
